import React, { PropTypes } from 'react';
import { Link } from 'react-router';


const Contact = ({ lang }) => (
  <div className="contact_container wow bounceInUp animated">
    <p>
      Contact <span className="firstname">Gaëlle</span>
      <a href="mailto:contact@luraschi.com">E-mail</a>
       Tel : + 33 3 44 54 04 50
    </p>
  </div>
);

Contact.propTypes = {
  lang: PropTypes.string.isRequired,
};

export default Contact;



// WEBPACK FOOTER //
// ./common/components/Contact.js